import { MailParameters } from './mail-paremeters';
import { Recipient } from './recipient.model';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StudentService } from '../../shared-components/student/student.service';
import { YearService } from '../../shared-components/year/year.service';
import { UserService } from '../../shared-components/user/user.service';
import { System } from '../../shared-components/System';
import { map } from 'rxjs/operators';
import { LoginService } from '../login/login.service';

@Injectable()
export class SendEmailService {

    // Properties
    private _teacherName: string;
    private _teacherEmailAddress: string;
    allAdvisors = false;
    allCounselors = false;
    allPrincipals = false;
    allSiteAdmin = false;
    allDistrictAdmin = false;
    allCoTeachers = false;
    allNurses = false;
    from360Portal = false;
    from360Email: string;
    subject: string;

    private _recipients: Recipient[] = [];
    private observableRecipients = new BehaviorSubject<Recipient[]>(this._recipients);
    observableRecipientsStream$ = this.observableRecipients.asObservable();

    // Class Functions
    constructor(
        private http: HttpClient,
        private studentService: StudentService,
        private yearService: YearService,
        private userService: UserService,
        private loginService: LoginService
    ) {}

    get recipients(): Recipient[] {
        return this._recipients;
    }

    set recipients(value: Recipient[]) {
        this._recipients = value;
        this.observableRecipients.next(this._recipients);
    }

    get teacherName(): string {
        // This makes it so the teacher name can only be obtained once
        const name = this._teacherName;
        this._teacherName = '';
        return name;
    }

    set teacherName(value: string) {
        this._teacherName = value;
    }

    get teacherEmailAddress(): string {
        // This makes it so the teacher email address can only be obtained once
        const email = this._teacherEmailAddress;
        this._teacherEmailAddress = '';
        return email;
    }

    set teacherEmailAddress(value: string) {
        this._teacherEmailAddress = value;
    }

    // Methods
    getStudentRecipients (viewOption: number): Observable<Recipient[]> {
        // PRE: a view option
        // POST: returns the recipients for the view option
        const queryString = '?studentId=' + this.studentService.selectedStudent.Id +
            '&userId=' + this.userService.currentUser.Id +
            '&yearId=' + this.yearService.defaultYear.Id +
            '&siteYearId=' + this.studentService.studentEnrollment.SiteYearId +
            '&viewOption=' + viewOption +
            '&allAdvisors=' + this.allAdvisors +
            '&allCounselors=' + this.allCounselors +
            '&allPrincipals=' + this.allPrincipals +
            '&allSiteAdmin=' + this.allSiteAdmin +
            '&allDistrictAdmin=' + this.allDistrictAdmin +
            '&allCoTeachers=' + this.allCoTeachers +
            '&allNurses=' + this.allNurses
            ;
        return this.http.get<Recipient[]>(System.apiURL.Student + 'GetStudentRecipients' + queryString).pipe(
            map(recipients => {
                this.recipients = recipients;
                return this.recipients;
            })
        );
    }

    sendEmail(parameters: MailParameters, area: string, noStudent: boolean = false, documentIds: string = ''): Observable<any> {
        // PRE: a list of parameters for the email and an area to send it from
        // POST: sends the email from the server
        const schoolId = this.yearService.defaultYear.SchoolID > 0 ? this.yearService.defaultYear.SchoolID : 0;
        const studentId = noStudent ? 0 : this.studentService.selectedStudent.Id;

        const queryString = '?yearId=' + this.yearService.defaultYear.Id +
            '&studentId=' + studentId +
            '&schoolId=' + schoolId +
            '&area=' + area +
            '&documentIds=' + documentIds;
        return this.http.post<any>(System.apiURL.Student + 'SendEmail' + queryString, parameters);
    }
}
